/* lib/adapters/knowledge.js — адаптер базы знаний.
 * Документ из бэка (WorkspaceDocumentSerializer) уже 1:1 с тем, что рисует DocumentCard
 * (id/filename/kind/summary/summary_status/summary_error/is_image/deep_readable/url/created_at/size_bytes),
 * поэтому сам документ НЕ адаптируем. Адаптер нужен только для:
 *   1) опций типа документа (value === backend KIND_CHOICES slug);
 *   2) квоты: used_mb приходит Decimal-строкой → Number; лимит -1 (безлимит) → null,
 *      иначе гейты количества/объёма (`?? Infinity`) и размера файла (DropZone `fileLimitMb ? … : Infinity`)
 *      приняли бы -1 за реальный лимит и заблокировали бы любую загрузку. */

// value совпадает с WorkspaceDocument.KIND_CHOICES (menu/standards/suppliers/other).
export const DOC_KIND_OPTIONS = [
  { value: 'menu', label: 'Меню' },
  { value: 'standards', label: 'Стандарты' },
  { value: 'suppliers', label: 'Поставщики' },
  { value: 'other', label: 'Прочее' },
];

const num = (v) => (v == null || v === '' ? 0 : Number(v));
// -1 (UNLIMITED) и null → null = «без лимита»; иначе число.
const noLimit = (v) => (v === -1 || v == null ? null : Number(v));

export function adaptDocQuota(q) {
  q = q || {};
  return {
    used_count: num(q.used_count),
    limit_count: noLimit(q.limit_count),
    used_mb: num(q.used_mb),
    limit_mb: noLimit(q.limit_mb),
    file_limit_mb: noLimit(q.file_limit_mb),
  };
}
